angular.module('directives', [
    'directives.restrictAccess',
    'directives.loadSpinner',
    'directives.uiNav',
    'directives.uiToggleClass',
    'directives.editableDecimal',
    'directives.smartDecimal',
    'directives.percentInput',
    'directives.dashboard',
    'directives.enterAsTab'
]);
